<template>
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.308 1.0746C14.5646 0.459828 15.4356 0.459826 15.6922 1.0746L19.1685 9.40203C19.271 9.64772 19.4962 9.82062 19.76 9.85633L28.871 11.0895C29.5212 11.1775 29.7529 11.999 29.2446 12.4138L22.189 18.1714C21.9675 18.3521 21.868 18.643 21.9325 18.9215L24.1895 28.6752C24.3446 29.3453 23.591 29.8533 23.028 29.4581L15.4309 24.1261C15.1724 23.9446 14.8278 23.9446 14.5692 24.1261L6.97213 29.4582C6.40909 29.8533 5.6555 29.3454 5.81057 28.6752L8.0675 18.9215C8.13195 18.643 8.03247 18.3521 7.811 18.1714L0.75555 12.4138C0.247225 11.9989 0.47897 11.1775 1.12914 11.0895L10.2402 9.85633C10.504 9.82062 10.7291 9.64772 10.8317 9.40203L14.308 1.0746Z"
      fill=""
    />
  </svg>
</template>
